import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminMaintenance from "@/pages/admin/AdminMaintenance";

export const Route = createFileRoute("/admin/maintenance")({
  head: () => pageHead("Admin \u2014 Maintenance \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminMaintenance,
});
